// @flow

import React from 'react';
import classNames from 'classnames/bind';
import style from './style.css';

type Props = {
  +size?: 'xs' | 'sm' | 'md'
};

const cx = classNames.bind(style);

const Spinner = (props: Props) => {
  const {size = 'md'} = props;

  return (
    <div className={cx('dispute-spiner')}>
      <div className={cx('dispute-spiner__spinner', `dispute-spiner__spinner--${size}`)} />
    </div>
  );
};

export default Spinner;
